const durationHorizontal = 1.8;
const delayMultiplierHorizontal = durationHorizontal / 10;

const durationVertical = 1.3;
const delayMultiplierVertical = durationVertical / 10;
const delayVertical = 0.3;

export const getImpulseFromCenterDuration = (
  horizontalLinesCount: number,
  verticalLinesCount: number,
): number => {
  const horizontalDuration =
    durationHorizontal +
    Math.floor(horizontalLinesCount / 2) * delayMultiplierHorizontal;

  const verticalDuration =
    durationVertical +
    Math.floor(verticalLinesCount / 2) * delayMultiplierVertical +
    delayVertical;

  return Math.max(horizontalDuration, verticalDuration);
};

export const getImpulseFromCenterHorizontalDelay = (index: number): number => {
  return Math.sqrt(index) * delayMultiplierHorizontal;
};

export const getImpulseFromCenterVerticalDelay = (index: number): number => {
  return Math.sqrt(index) * delayMultiplierVertical + delayVertical;
};

export const impulseFromCenterConfig = {
  durationHorizontal,
  delayMultiplierHorizontal,
  durationVertical,
  delayMultiplierVertical,
};
